import type { HTMLAttributes } from 'react';
import { cx } from '../internal/cx';
import styles from './Spinner.module.css';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

export interface SpinnerProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  size?: SpinnerSize;
  /** Announced to screen readers. Ignored when `decorative`. */
  label?: string;
  /** Hide from assistive technology (e.g. when a parent already has aria-busy). */
  decorative?: boolean;
}

export function Spinner({
  size = 'md',
  label = 'Loading',
  decorative = false,
  className,
  ...rest
}: SpinnerProps) {
  return (
    <span
      className={cx(styles.root, styles[size], className)}
      {...(decorative ? { 'aria-hidden': true } : { role: 'status' })}
      {...rest}
    >
      <svg className={styles.svg} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle className={styles.track} cx="12" cy="12" r="9.5" strokeWidth="3" />
        <path
          className={styles.arc}
          d="M21.5 12a9.5 9.5 0 0 0-9.5-9.5"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {!decorative && <span className="sr-only">{label}</span>}
    </span>
  );
}
